module.exports = __webpack_public_path__ + "static/media/iq.77fca3a1.svg";